export default __webpack_public_path__ + "static/media/PrimeCuts.ed31a9d7.jpg";